module.exports = __webpack_public_path__ + "static/media/arrow-right.2e547a0f.svg";